"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ palette, spacing, shadows, shape }) => ({
    root: {
        padding: spacing(1, 0),
        backgroundColor: palette.surface,
        boxShadow: shadows[2],
        borderRadius: shape.borderRadius,
        overflow: 'auto',
    },
}));
exports.decorate = styles_1.withStyles(styles);
